import { Route, Routes } from "react-router-dom";
import { Routes as UserRoutes } from "./routes";
import { UserRouterCmp } from "./types";
import { UserDetailPage, UserSearchPage } from "../pages";
import { UserPermissionSearchPage } from "../pages/UserDetailPage/components/UserDetailCard/components/UserPermissionSearchPage";


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UserRouter: UserRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={UserSearchPage.route} element={<UserSearchPage />} />
        <Route path={UserDetailPage.route} element={<UserDetailPage />} />
        <Route path={UserPermissionSearchPage.route} element={<UserPermissionSearchPage />} />
      </Routes>
    </>
  );
};

UserRouter.route = UserRoutes.UserRouter;

export default UserRouter;
